import { initializeBlock } from "./";
import { initializeFrontendBlocks } from "@/utils/acf-blocks";
import { name } from "./block.json";

initializeFrontendBlocks(name, initializeBlock);
